const storeToken = (value) => {
  if (value) {
    localStorage.setItem("access", JSON.stringify(value.access));
    localStorage.setItem("refresh", JSON.stringify(value.refresh));
  }
};

const storeResponse = (value) => {
  if (value) {
    localStorage.setItem("user_id", value.user_id);
    localStorage.setItem("name", value.name);
    // RBAC: store role and allowed_pages returned by backend login response
    if (value.role !== undefined) {
      localStorage.setItem("role", value.role);
    }
    if (value.allowed_pages !== undefined) {
      localStorage.setItem("allowed_pages", JSON.stringify(value.allowed_pages));
    }
  }
};

const getToken = () => {
  let access_token = localStorage.getItem("access");
  let refresh_token = localStorage.getItem("refresh");
  return { access_token, refresh_token };
};

const getUserRole = () => {
  return localStorage.getItem("role") || localStorage.getItem("name") || null;
};

// RBAC: get the list of page keys the user is allowed to access
const getAllowedPages = () => {
  try {
    return JSON.parse(localStorage.getItem("allowed_pages") || "[]");
  } catch {
    return [];
  }
};

const removeToken = () => {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("name");
  localStorage.removeItem("user_id");
  localStorage.removeItem("role");
  localStorage.removeItem("allowed_pages");
};

export {
  storeToken,
  getToken,
  removeToken,
  storeResponse,
  getUserRole,
  getAllowedPages,
};